import React from "react";

import {
  CarBrand,
  CarModel,
  CommonConfigService,
  Country,
  VehicleType,
} from "@egis-smartcity/parking";

export type CommonConfigState = {
  commonConfigService?: CommonConfigService;
  carBrands?: CarBrand[];
  carModels?: CarModel[];
  countries?: Country[];
  vehicleTypes?: VehicleType[];
};

export const CommonConfigContext = React.createContext<
  CommonConfigState | undefined
>(undefined);

export default CommonConfigContext;
